import { render } from "./Thorondor-AgentesView.vue?vue&type=template&id=4151445a"
import script from "./Thorondor-AgentesView.vue?vue&type=script&lang=js"
export * from "./Thorondor-AgentesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__